import React from 'react';

/**
 * Base card primitive used across the Dashboard.
 * Dark-theme first, indigo-accented border on hover.
 */
function Card({ children, className = '', hover = false, ...props }) {
  const hoverClasses = hover
    ? 'transition-colors hover:border-brand-500/40 hover:shadow-md'
    : '';
  return (
    <div
      className={`bg-white dark:bg-slate-800/80 backdrop-blur-sm border border-slate-200 dark:border-slate-700/60 rounded-xl shadow-sm ${hoverClasses} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
